export function mapStringArrayToArrayKeyObject(arr: string[]) {
  return arr.map((key) => ({ key }));
}
